export default "__VITE_ASSET__d730ed50__"